<template>
  <div class="d-flex flex-column align-items-center p-5">
    <h1>
      지원한 프로젝트가 내 프로필에 등록되었습니다.
      <br />
      이제 다음 단계로 이동해주세요.
    </h1>
    <b-btn
      class="m-3"
      variant="primary"
      :to="{
        name: 'application-with-artwork',
        params: {
          inviteId,
          artworkId
        }
      }"
    >
      Next
    </b-btn>
    <hr class="w-100" />
    <div class="author">
      <div class="p-3">
        <author :author="user" />
      </div>
      <div class="card-container d-flex flex-wrap justify-content-center">
        <artwork
          :key="artwork.id"
          :artwork="artwork"
          :class="i >= 4 ? 'd-card' : null"
          new-window
          v-for="(artwork, i) in artworks.results.filter(
            a => a.id != $route.params.artwork
          )"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Artwork } from "../models";

export default {
  props: ["inviteId", "artworkId"],
  data() {
    return {
      user: window.user,
      artworks: {
        results: []
      }
    };
  },
  async created() {
    this.artworks = await new Artwork().byUser(this.user.id);
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 30px;
  text-align: center;
}

.author {
  padding-bottom: 50px;

  .card-container {
    overflow: hidden;

    @media (min-width: 512px) {
      max-height: 544px;
    }

    .card {
      margin: 7.5px;
      max-width: calc(50% - 15px);

      &.d-card {
        display: none;

        @media (min-width: 512px) {
          display: block;
        }
      }
    }
  }
}
</style>
